import * as u from "react";
import "../../../../rc-util/es/hooks/useLayoutEffect.mjs";
import "../../../../rc-util/es/ref.mjs";
import { warningOnce as A } from "../../../../rc-util/es/warning.mjs";
import { getShadowRoot as B } from "../../../../rc-util/es/Dom/shadow.mjs";
import j from "../../../../rc-util/es/raf.mjs";
import { getWin as F } from "../util.mjs";
function U(f, l, r, n, x, O, V, k) {
  var s = u.useRef(f), m = u.useRef(!1);
  s.current !== f && (m.current = !0, s.current = f), u.useEffect(function() {
    var i = j(function() {
      m.current = !1;
    });
    return function() {
      j.cancel(i);
    };
  }, [f]), u.useEffect(function() {
    if (l && n && (!x || O)) {
      var i = !1, v = function(L) {
        var o = L.target;
        i = V(o);
      }, c = function(L) {
        var o = L.target;
        !m.current && s.current && !i && !V(o) && k(!1);
      }, t = F(n);
      t.addEventListener("mousedown", v), t.addEventListener("click", c);
      var e = B(r);
      if (e && (e.addEventListener("mousedown", v), e.addEventListener("click", c)), process.env.NODE_ENV !== "production") {
        var a, d, q = r == null || (a = r.getRootNode) === null || a === void 0 ? void 0 : a.call(r), y = (d = n.getRootNode) === null || d === void 0 ? void 0 : d.call(n);
        A(q === y, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        t.removeEventListener("mousedown", v), t.removeEventListener("click", c), e && (e.removeEventListener("mousedown", v), e.removeEventListener("click", c));
      };
    }
  }, [l, r, n, x, O]);
}
export {
  U as default
};
//# sourceMappingURL=useWinClick.mjs.map
